import React, { Dispatch } from "react"

import { IGetJobsResponse } from "api/reactQuery/queries/jobs.types"
import { IShortClassStudent } from "api/reactQuery/queries/shortClassList.types"

import { ICheckedPerson, IStudentsToChecked } from "../Jobs"
import SingleGrid from "./SingleGrid"

interface IJobsOffer {
  data: IGetJobsResponse[]
  students: IShortClassStudent[]
  setRichEditorResponsibilities: Dispatch<React.SetStateAction<string>>
  richEditorResponsibilities: string
  setRichEditorQualifications: Dispatch<React.SetStateAction<string>>
  richEditorQualifications: string
  checkedPerson: ICheckedPerson[]
  setStudentsToChecked: Dispatch<React.SetStateAction<IStudentsToChecked[]>>
  setCheckedPerson: Dispatch<React.SetStateAction<ICheckedPerson[]>>
  isRefetching: boolean
}

const jobsOffer = ({
  setRichEditorResponsibilities,
  richEditorResponsibilities,
  setRichEditorQualifications,
  richEditorQualifications,
  data,
  students,
  checkedPerson,
  setStudentsToChecked,
  setCheckedPerson,
  isRefetching,
}: IJobsOffer) => {
  const totalJobs = data.length

  return (
    <>
      {data
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((el) => (
          <SingleGrid
            isRefetching={isRefetching}
            richEditorQualifications={richEditorQualifications}
            setRichEditorQualifications={setRichEditorQualifications}
            richEditorResponsibilities={richEditorResponsibilities}
            setRichEditorResponsibilities={setRichEditorResponsibilities}
            key={el.id}
            jobsOffer={el}
            students={students}
            allOfClasses={data}
            checkedPerson={checkedPerson}
            setStudentsToChecked={setStudentsToChecked}
            setCheckedPerson={setCheckedPerson}
            totalJobs={totalJobs}
          />
        ))}
    </>
  )
}

export default jobsOffer
